import styled, { css } from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'
import { AUTO_ATTR_KEY, AutomationId } from 'utils/automationUtil'

export const StyledContainer = styled.div`
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  display: grid;
  grid-template-columns: 48px 1fr;
  padding: 9px 0 0 8px;
  margin-bottom: 5px;
  border-top: 1px solid ${({ mode }: { mode: Theme }) => sys[mode].common.divider[100]};
`

export const StyleAuthorContainer = styled.div`
  display: flex;
  direction: ltr;
  gap: 4px;
`

export const StyledContentContainer = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-left: 12px;
  padding-right: 9px;
  overflow-x: hidden;
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};
`

export const StyledHeaderContainer = styled.div`
  width: 100%;
  min-width: 0;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`

export const StyledHeaderLeft = styled.div`
  width: 100%;
  height: auto;
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
`

const HeaderRightStyles = css`
  color: ${({ mode }: { mode: Theme }) => sys[mode].text.placeholder};
  line-height: ${sys.typescale[12].lineHeight};
  font-size: ${sys.typescale[12].size};
  font-weight: 400;
`

export const DateStyle = css`
  ${HeaderRightStyles}
  overflow: hidden;
  text-overflow: ellipsis;
`

export const StyledHeaderRight = styled.div`
  ${HeaderRightStyles}
  width: fit-content;
  min-width: 0px;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-left: 16px;
`

export const StyledDomainLink = styled.a.attrs({
  [AUTO_ATTR_KEY]: AutomationId.soundbiteDefaultFrame.domainLink
})<{ disabled?: boolean }>`
  text-decoration: none;
  align-items: center;
  display: flex;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`

export const EllipsisStyles = css`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  word-break: break-word;
`

export const OneLineEllipsisStyles = css`
  ${EllipsisStyles}
  -webkit-line-clamp: 1;
`

export const AuthorStyles = css`
  ${OneLineEllipsisStyles}
  font-size: ${sys.typescale[14].size};
  font-weight: ${sys.fontWeight.regular};
  line-height: ${sys.typescale[14].lineHeight};
`

export const AuthorHandleStyles = css`
  ${AuthorStyles}
  min-width: 25px;
`

export const IconStyles = css`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  line-height: 22px;
  border-radius: 2px;
`

export const ActionIconStyles = css`
  ${IconStyles}
  color: ${({ mode }: { mode: Theme }) => sys[mode].text.placeholder};
  font-size: ${sys.typescale[14].size};
  font-weight: 400;
`

export const MetadataIconStyles = css`
  ${IconStyles}
  padding: 3px 16px 3px 2px;
  font-size: ${sys.typescale[14].size};
`

export const StyledIconContainer = styled.div`
  height: 22px;
  display: flex;
  align-items: center;
`

export const StyledLink = styled.a`
  color: ${({ mode }: { mode: Theme }) => sys[mode].interaction.primary.default};
  text-decoration: underline;
  &:hover {
    color: ${({ mode }: { mode: Theme }) => sys[mode].interaction.primary.hover};
  }
`

export const StyledContent = styled.div`
  color: ${({ mode }: { mode: Theme }) => sys[mode].text.primary};
  line-height: ${sys.typescale[14].lineHeight};
  font-size: ${sys.typescale[14].size};
  font-weight: 400;

  & a {
    color: ${({ mode }: { mode: Theme }) => sys[mode].interaction.primary.default};
    &:hover {
      color: ${({ mode }: { mode: Theme }) => sys[mode].interaction.primary.hover};
    }
  }
`

export const StyledInfoContainer = styled.div.attrs({
  [AUTO_ATTR_KEY]: AutomationId.soundbiteDefaultFrame.sharedInfo
})`
  display: flex;
  align-items: center;
  gap: 3px;
  color: ${({ mode }: { mode: Theme }) => sys[mode].text.placeholder};
  line-height: ${sys.typescale[12].lineHeight};
  font-size: ${sys.typescale[12].size};
  font-weight: 400;
  word-break: break-word;
`

const IconGroupStyles = css`
  width: 100%;
  min-width: 0;
  display: flex;
  align-items: center;
  flex-flow: row wrap;
  gap: 0px;
`

export const StyledActionContainer = styled.div.attrs({
  [AUTO_ATTR_KEY]: AutomationId.soundbiteDefaultFrame.actionItems
})`
  ${IconGroupStyles}
  margin-left: -8px;
`

export const StyledMetadataContainer = styled.div.attrs({
  [AUTO_ATTR_KEY]: AutomationId.soundbiteDefaultFrame.metadata
})`
  ${IconGroupStyles}
  border-top: 1px solid ${({ mode }: { mode: Theme }) => sys[mode].common.divider[100]};
  margin-top: 1px;
  padding-top: 8px;
`

export const StyledOtherAuthorsSpan = styled.span`
  &:hover {
    color: ${({ mode }: { mode: Theme }) => sys[mode].text.weak};
  }
`

export const StyledSentimentContainer = styled.div`
  display: flex;
`

export const StyledLoadMoreContainer = styled.div`
  width: 100%;
  min-width: 0;
  display: flex;
  grid-template-columns: 48px 1fr;
  padding: 9px 8px 0 8px;
  margin-top: 5px;
  position: sticky;
  top: 50%;
  left: 50%;
`

export const StyledUserLink = styled(StyledLink)`
  padding-right: ${({ displayTrailingSpace }: { displayTrailingSpace: boolean }) =>
    displayTrailingSpace ? '4px' : 0};
`
